import { track } from '@mc/track-event'

export const trackViewedSubcategoryDynamicHeader = ({
  headline,
  subcategorySlug,
  isDynamicHero,
}: {
  headline: string
  subcategorySlug: string
  isDynamicHero: boolean
}) => {
  track('Viewed Subcategory Dynamic Header', {
    headline,
    subcategory_slug: subcategorySlug,
    context: {
      dynamic_header: isDynamicHero,
    },
  })
}
